/**
 * Environment types for the application
 */
export enum envType {
	LOCAL = 'local',
	DEV = 'dev',
	STAGING = 'staging',
	PROD = 'prod',
}

/**
 * Environment configuration interface
 */
export interface EnvironmentConfig {
	type: envType;
	isLocal: boolean;
	isStaging: boolean;
	isProd: boolean;
	isDev: boolean;
	hostname: string;
	remoteDomain?: string;
}
